<template>
  <b-container>
  </b-container>
</template>
<script>
export default {
  created () {
    if (this.$route.query.access_token) {
      localStorage.setItem('userToken', this.$route.query.access_token)
      this.$store.commit('loginStatus', true)
      this.$router.push('/')
    }
  }
}
</script>
